import React from 'react';

// import { NavLink as RouterLink } from 'react-router';
import styled from '@emotion/styled';

interface SignInWrapperProps {
  children: React.ReactNode;
  formHeaderTitle?: string;
  formHeaderDescription?: string | React.ReactNode;
}

const SignInWrapper: React.FC<SignInWrapperProps> = ({
  children,
  formHeaderTitle,
  formHeaderDescription,
}) => {
  return (
    <Container>
      <FormSectionHeader>
        <FormSectionHeaderTitle>{formHeaderTitle}</FormSectionHeaderTitle>
        <FormSectionHeaderDescription>
          {formHeaderDescription}
        </FormSectionHeaderDescription>
      </FormSectionHeader>
      <HorizontalDivider />
      {children}
      {/* <FormFooter>
        Don’t have an account? <Link to={'/account/signup'}>Sign up</Link>
      </FormFooter> */}
    </Container>
  );
};

export default SignInWrapper;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 440px;
  margin: 0 auto;
  padding: 36px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: 24px;
  box-shadow: 0 30px 60px -40px rgba(14, 26, 19, 0.35);

  @media (max-width: 884px) {
    width: 100%;
    max-width: 440px;
    padding: 28px 22px;
  }
`;

const HorizontalDivider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${({ theme }) => theme.palette.borderColor};

  @media (max-width: 884px) {
    display: none;
  }
`;

const FormSectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 884px) {
    width: 100%;
  }
`;

const FormSectionHeaderTitle = styled.h1`
  margin: 0;
  display: flex;
  text-align: left;
  font-family: var(--font-display);
  font-size: 30px;
  line-height: 1.05;
  font-weight: 800;
  letter-spacing: -0.03em;
  color: ${({ theme }) => theme.palette.HetheraBlack};
`;

const FormSectionHeaderDescription = styled.div`
  display: flex;
  text-align: left;
  font-size: 15px;
  line-height: 1.5;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.formDescriptionText};
`;

// const FormFooter = styled.div`
//   margin: 0 72px;
//   font-size: 12px;
//   text-align: center;
//   color: ${({ theme }) => theme.palette.formFooterText};

//   @media (max-width: 884px) {
//     gap: 0px;
//   }
// `;

// const Link = styled(RouterLink)`
//   text-decoration: none;
//   color: ${({ theme }) => theme.palette.HetheraPrimary};
//   font-weight: 600;
// `;
